import Axios from "axios";
import { protectedResources } from "../authConfig";
import { getPersonId } from "./ApiGetPersonId";
import { shareInFlight } from "../helpers/shareInFlight";

const URL =
  protectedResources.apiHRMobile.baseApi + "/api/v1/TimeInOut/GetUserInfo";
let tokenKey;

// App.tsx and UserContext both load the user on start; share one request instead of calling the API twice.
const inFlight = new Map();

export async function getInfoUsers(email = '') {
  // ถ้าไม่มี email ให้ลองดึงจาก sessionStorage['email']
  if (!email) {
    const emailFromSession = sessionStorage.getItem('email');
    if (emailFromSession) {
      email = emailFromSession;
    }
  }

  return shareInFlight(inFlight, (email || '').toLowerCase(), () => loadInfoUsers(email));
}

async function loadInfoUsers(email) {

  // First check if we have cached data
  const cacheKey = `cache_user_info_${email}`;
  const cachedData = sessionStorage.getItem(cacheKey);
  
  if (cachedData) {
    const parsedData = JSON.parse(cachedData);
    // Set the local storage as well for other components that might depend on it
    localStorage.setItem("obj_user_info", cachedData);
    return parsedData;
  }
  
  // No cached data, proceed with API call
  if (sessionStorage.getItem("AccessToken") !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem("AccessToken")).value;
    localStorage.setItem("AccessTokens", tokenKey);
  }
  
  // personId (Entra ID employeeId) is the fastest Simond lookup; the API checks it belongs to the signed-in user.
  // Without it the email is sent; the API remembers which employee an email belongs to after the first lookup.
  const personId = await getPersonId(email);
  const params = personId ? { personId } : { emailOrId: email };

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
    params,
    paramsSerializer: params => {
      return Object.entries(params)
        .filter(([_, v]) => v !== undefined && v !== null && v !== '')
        .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
        .join('&');
    }
  };

  try {
    console.log('Sending GET request to:', URL, 'with params:', config.params);
    const response = await Axios.get(URL, config);
    console.log('API response successful:', response.status);
    // Check for valid JSON/object response
    if (!response.data || typeof response.data !== 'object') {
      console.error('API response is not valid JSON:', response.data);
      throw new Error('API did not return valid JSON data.');
    }
    // Cache the response in sessionStorage (10 minutes)
    sessionStorage.setItem(cacheKey, JSON.stringify(response.data));
    setTimeout(() => {
      sessionStorage.removeItem(cacheKey);
    }, 600000); // 10 minutes

    localStorage.setItem("obj_user_info", JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error('API request failed:', {
      url: URL,
      params: config.params,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      responseData: error?.response?.data
    });

    if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    
    
    throw error;
  }
}
